import type { ReactNode } from 'react';
import { Group, Stack, Text, Title } from '@mantine/core';

interface Props {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function PageHeader({ eyebrow, title, subtitle, actions }: Props) {
  return (
    <Group justify="space-between" align="flex-end" wrap="nowrap">
      <Stack gap={4}>
        {eyebrow && (
          <Text fz="xs" tt="uppercase" lts="0.06em" c="var(--wheels-ink-muted)" fw={600}>
            {eyebrow}
          </Text>
        )}
        <Title order={2} c="var(--wheels-ink-strong)" fw={600}>
          {title}
        </Title>
        {subtitle && (
          <Text fz="sm" c="var(--wheels-ink-muted)">
            {subtitle}
          </Text>
        )}
      </Stack>
      {actions && <Group gap="sm">{actions}</Group>}
    </Group>
  );
}
